import { ApiCall } from "../apiBase";

/******* Upload Images to S3 and Get URL ******/
export async function getS3SingedUrl(fileName) {
  let signedURL = null

  const result = await ApiCall({
    method: 'post',
    data: {
      query: `
        mutation getS3SignedUrl($input: FileName) {
          getS3SignedUrl(input: $input) {
            signedUrl
          }
        }
      `,
      variables: {
        input: {
          fileName: fileName
        },
      },
    },
  });

  if (!result.data.errors && result.data.data.getS3SignedUrl) {
    signedURL = result.data.data.getS3SignedUrl
  }

  return signedURL
}